import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

// ================== Admin Login ==================
export const adminLogin = (data) => {
  return axios.post(`${API_BASE}/admin/login`, data, {
    headers: { "Content-Type": "application/json" },
  });
};

// ================== Admin: Protected Requests ==================
export const listApplications = (token) =>
  axios.get(`${API_BASE}/admin/applications`, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const replyToApplication = (id, data, token) =>
  axios.put(`${API_BASE}/admin/applications/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const resendApplicationEmail = (id, token) =>
  axios.post(`${API_BASE}/admin/applications/resend/${id}`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });